import {mapMutations} from 'vuex'

export const popups = {
  methods: {
    ...mapMutations({
      overlay: 'popups/SHOW_OVERLAY',
      showRight: 'popups/SHOW_RIGHT',
      errorLogin: "popups/errorLogin/SHOW_ERROR_LOGIN",
      delConfirmClose: 'popups/delItem/SET_SHOW',
      addUserToggle: 'popups/addUser/SET_SHOW',
      //editUserToggle: 'users/SET_SHOW_EDIT',
      //editGroupToggle: 'users/SET_SHOW_EDIT_GROUP',
      setGroupUserToggle: 'popups/setGroupUser/SET_SHOW',
      setAddThingToggle: 'popups/addThing/SET_SHOW',
      setAddRoleToggle: 'popups/addRole/SET_SHOW',
      setAddRoleInGroupToggle: 'popups/addRoleInGroup/SET_SHOW',
      setShowAssignRoleToGroup: 'popups/assignRole/SET_SHOW',
      setShowDelPopup: 'popups/del/SET_SHOW',
      setShowUnsetGroup: 'popups/del/SET_SHOW_UNSET',
      setShowReinvite: 'roles/SET_SUCCESS_INVITE',
      setShowAddUserPopup: 'popups/addUser/SET_SHOW',
      setShowLoader: 'popups/SHOW_LOADER',
      setShowReinviteSuccessPopup: 'roles/SET_INNVITE_SUCCESS',
      setMergeGroup: 'things/SET_MERGE_GROUP',
      setMergeVirtual: 'things/SET_MERGE_VIRTUAL',
      setThingDelConfirmToggle: 'things/SET_SHOW_DEL',
      setShareThingToggle: 'things/SET_SHOW_SHARE',
      setShowThingRightsControlToggle: 'things/SET_RIGHTS_CONTROL',
      setShowChangeOwnerThingToggle: 'things/SET_SHOW_CHANGE_OWNER',
      setShowErrorMergeThingToggle: 'things/SET_ERROR_MERGE_THING',
      setShowCreateProjectToggle: 'projects/SET_SHOW_CREATE_PROJECT',
      setShowAddPermissionProject: 'projects/SET_SHOW_ADD_PERMISSION',
      setShowAddSectionProject: 'projects/SET_SHOW_ADD_SECTION',
      setShowDelItemProject: 'projects/SET_SHOW_DEL_POPUP',
      setShowAddInfoBlock: 'popups/addInfoBlock/SET_SHOW',
      setShowDelSingleProject: 'popups/delSingleProject/SET_SHOW',
      setShowDelRoleProjects: 'projects/SET_SHOW_DEL_ROLE_PROJECT',
      setShowAddThingInProject: 'projects/SET_ADD_THING_IN_PROJECT',
      setShowRemoveThingProject: 'projects/SET_SHOW_DEL_THING_PROJECT',
      setShowAddEventNamePopup: 'journal/SET_SHOW_ADD_EVENT_NAME_POPUP'
    }),
    closeAll() {
      this.overlay(false);
      this.errorLogin(false);
      this.delConfirmClose(false);
      this.addUserToggle(false);
      // this.editUserToggle(false);
      // this.editGroupToggle(false);
      this.showRight(false);
      this.setGroupUserToggle(false);
      this.setAddThingToggle(false);
      this.setAddRoleToggle(false);
      this.setAddRoleInGroupToggle(false);
      this.setShowAssignRoleToGroup(false);
      this.setShowDelPopup(false);
      this.setShowUnsetGroup(false);
      this.setShowReinvite(false);
      this.setShowAddUserPopup(false);
      this.setShowLoader(false);
      this.setShowReinviteSuccessPopup(false);
      this.setMergeGroup(false);
      this.setMergeVirtual(false);
      this.setThingDelConfirmToggle(false);
      this.setShareThingToggle(false);
      this.setShowThingRightsControlToggle(false);
      this.setShowChangeOwnerThingToggle(false);
      this.setShowErrorMergeThingToggle(false);
      this.setShowCreateProjectToggle(false);
      this.setShowAddPermissionProject(false);
      this.setShowAddSectionProject(false);
      this.setShowDelItemProject(false);
      this.setShowAddInfoBlock(false);
      this.setShowDelSingleProject(false);
      this.setShowDelRoleProjects(false);
      this.setShowAddThingInProject(false);
      this.setShowRemoveThingProject(false);
      this.setShowAddEventNamePopup(false);


      document.documentElement.style.overflow = 'auto'
    },
    closeDel() {
      this.overlay(false);
      this.delConfirmClose(false);
      this.setShowDelPopup(false);
      this.setThingDelConfirmToggle(false);
      this.setShowDelItemProject(false);
      document.documentElement.style.overflow = 'auto';
    },
    closeSet() {
      //this.overlay(false);
      this.setGroupUserToggle(false);
      document.documentElement.style.overflow = 'auto'

    }
  }
}
